import { render, staticRenderFns } from "./LuExciseProjectionTypeDialog.vue?vue&type=template&id=749e107c&"
import script from "./LuExciseProjectionTypeDialog.vue?vue&type=script&lang=js&"
export * from "./LuExciseProjectionTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports